import { gql } from "@/__generated__/gql";

export const USERS_BY_ROLE = gql(`
  query UsersByRole(
    $orgId: ID!
    $roles: [UserRoleEnum!]!
    $first: Int
    $after: String
    $imageSize: Int!
    $omissions: [UserOmissionAttributeEnum!]
  ) {
    node(id: $orgId) {
        ... on Organization {
        id
        users(first: $first, after: $after, roles: $roles, omissions: $omissions) {
          edges {
            node {
              id
              uuid
              firstName
              lastName
              name @client
              role
              profilePhoto {
                id
                url(size: $imageSize)
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          totalCount
        }
      }
    }
  }
`);
